module.exports = __webpack_public_path__ + "img/ai.1a45bc8c.png";